import React from 'react'
import Link from 'next/link'
import useNativeLazyLoading from '@charlietango/use-native-lazy-loading'
import { useInView } from 'react-intersection-observer'

import LazyImage from '../LazyImage'

export default function PartnerLogos (props) {
  const [slideUpRef, isInView] = useInView({ triggerOnce: true })

  const { logoHeading, logoParagraph } = props

  const renderLogos = items => {
    if (!items) return

    return items.map(item => {
      let data
      if (props.documentary) data = item.documentary_been_image
      else data = item.partner_logo
      var link = item.partner_link
      const supportsLazyLoading = useNativeLazyLoading()
      const [slideUpRef, isInView] = useInView({ triggerOnce: true })

      return (
        <div
          key={data.id}
          className='col-6 col-md-4 col-lg-3 logo align-self-center'
        >
          {props.documentary ? (
            <div
              ref={slideUpRef}
              className={`partner__logo animation ${
                isInView ? 'logo-slide-up' : ''
              }`}
            >
              <LazyImage src={data.url} alt={data.alt} />
            </div>
          ) : link ? (
            <a
              aria-label={`${item.partner_name}'s Website`}
              href={link.url}
              target={link.target}
              rel={`${link.target == '_blank' ? 'noopener' : ''}`}
            >
              <div
                ref={slideUpRef}
                className={`partner__logo  animation ${
                  isInView ? 'slide-left' : ''
                }`}
              >
                <LazyImage src={data.url} alt='' />
              </div>
            </a>
          ) : (
            <div
              ref={slideUpRef}
              className={`partner__logo  animation ${
                isInView ? 'slide-left' : ''
              }`}
            >
              <LazyImage src={data.url} alt={data.partner_name} />
            </div>
          )}
        </div>
      )
    })
  }

  return (
    props.logos && (
      <React.Fragment>
        <div className='container-fluid where-we-been'>
          <div
            ref={slideUpRef}
            className={`row justify-content-center animation ${
              isInView ? 'slide-up' : ''
            } `}
          >
            <div className='col-10'>
              {logoHeading ? (
                <h2
                  className='heading2'
                  dangerouslySetInnerHTML={{ __html: logoHeading }}
                />
              ) : (
                ''
              )}

              {logoParagraph ? (
                <div dangerouslySetInnerHTML={{ __html: logoParagraph }} />
              ) : (
                ''
              )}
            </div>
          </div>

          {props.logos && (
            <div className={`row `}>{renderLogos(props.logos)}</div>
          )}
          {/*.row*/}
        </div>
        {/*.where-we-been*/}

        <style jsx>{`
          .row {
            max-width: 1570px;
            margin: 0 auto;
          }
          .partner__logo {
            opacity: 0;
          }
          .slide-up {
            padding-top: 0;
          }
        `}</style>
      </React.Fragment>
    )
  )
}
